export const STAFF_ACTIONS = {
  FETCH_ALL_STAFF: 'STAFF_ACTIONS/FETCH_ALL_STAFF',
  FETCH_COUNT_STAFF: 'STAFF_ACTIONS/FETCH_COUNT_STAFF',
  SET_OFFSET: 'STAFF_ACTIONS/SET_OFFSET',
  SET_STAFF: 'STAFF_ACTIONS/SET_STAFF',
  SET_COUNT_STAFF: 'STAFF_ACTIONS/SET_COUNT_STAFF',
  SET_LOADING_STATUS: 'STAFF_ACTIONS/SET_LOADING_STATUS',
  SET_PAGE_NUMBER: 'STAFF_ACTIONS/SET_PAGE_NUMBER',
  SHOW_ERROR: 'STAFF_ACTIONS/SHOW_ERROR',
  SET_ORDER: 'STAFF_ACTIONS/SET_ORDER',
  SET_SORT_BY: 'STAFF_ACTIONS/SET_SORT_BY',
  SET_SEARCH_TEXT: 'STAFF_ACTIONS/SET_SEARCH_TEXT',
};

export const putStaffLoadingStatus = (status) => ({
  type: STAFF_ACTIONS.SET_LOADING_STATUS,
  payload: status,
});

export const setStaff = (list) => ({
  type: STAFF_ACTIONS.SET_STAFF,
  payload: list,
});

export const showStaffError = () => ({
  type: STAFF_ACTIONS.SHOW_ERROR,
});

export const fetchStaff = () => ({
  type: STAFF_ACTIONS.FETCH_ALL_STAFF,
});

export const fetchCountStaff = () => ({
  type: STAFF_ACTIONS.FETCH_COUNT_STAFF,
});

export const putCountStaff = (count) => ({
  type: STAFF_ACTIONS.SET_COUNT_STAFF,
  payload: count,
});

export const putStaffOffset = (page) => ({
  type: STAFF_ACTIONS.SET_OFFSET,
  payload: page,
});

export const putStaffPageNumber = (pageNumber) => ({
  type: STAFF_ACTIONS.SET_PAGE_NUMBER,
  payload: pageNumber,
});

export const putOrder = (order) => ({
  type: STAFF_ACTIONS.SET_ORDER,
  payload: order,
});

export const putSortBy = (sortBy) => ({
  type: STAFF_ACTIONS.SET_SORT_BY,
  payload: sortBy,
});

export const setSearchText = (searchText) => ({
  type: STAFF_ACTIONS.SET_SEARCH_TEXT,
  payload: searchText,
});
